import { ShareModalIcon } from "assets/svg";
import React from "react";

const ModuleLayout = ({ title, children, shareModalHandler }) => {
  return (
    <div className="min-h-[750px] w-[100%] lg:w-[98%] ml-auto shadow-[0_4px_10px_rgba(0,0,0,0.1)] dark:shadow-[0_0px_3px_rgba(255,255,255,0.5)] flex flex-col mb-16 md:rounded-bl-md">
      <div className="bg-secondary h-auto w-full px-14 py-5 flex flex-col gap-2 items-start">
        <div className="flex w-full flex-col xs:flex-row xs:items-center justify-between">
          <div className="flex flex-col gap-2">
            <p className="text-white text-2xl font-bold">{title}</p>
          </div>
          {shareModalHandler && (
            <button
              className="bg-[#e89e2f] hover:bg-[#ff9900] text-[1em] rounded-md py-[10px] px-5 lg:px-3 xl:px-5 font-medium text-white flex items-center gap-3 lg:gap-1 xl:gap-3 transition-all duration-300"
              onClick={() =>
                shareModalHandler({ id: null, title: "Share your properties" })
              }>
              <img
                src={ShareModalIcon}
                alt=""
                className="w-4 h-4"
              />
              Share
            </button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default ModuleLayout;
